































import Vue from "vue";
export default Vue.extend({
  props: {
    title: {
      type: String,
    },
    numerator: {
      type: Number,
    },
    denominator: {
      type: Number,
      default: 100,
      required: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    isPercentage(): boolean {
      return this.denominator == 100;
    },
  },
  computed: {
    calculatedPercentage(): number {
      return (this.numerator / this.denominator) * 100;
    },
    isDisabled(): boolean {
      return this.denominator == 0;
    },
  },
});
